exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-gray{color:#fff;background:gray;border:1px solid #e7eaec}", "", {"version":3,"sources":["/./src/components/Common/deleteSweetAlert.vue"],"names":[],"mappings":"AACA,UACI,WAAa,AACb,gBAAiB,AACjB,wBAA0B,CAC7B","file":"deleteSweetAlert.vue","sourcesContent":["\n.btn-gray {\n    color: white;\n    background: gray;\n    border: 1px solid #e7eaec;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/components/Common/deleteSweetAlert.vue
// module id = 323
// module chunks = 0